<div class="image-container">
  <app-safe-image imgClass="mat-elevation-z1" [src]="imgSrc" [alt]="result?.title ?? 'Cover'" />
</div>

<div class="text-container-outer">
  <div class="text-container-inner">
    <h3 class="title">
      <span [innerHTML]="result?.title"></span>
    </h3>

    <div class="subtitle">
      @for (subtitleField of subtitleFields; track subtitleField; let last = $last) {
        <ng-container
          *ngTemplateOutlet="
            subtitleField.field === SearchResultFields.Period
              ? period
              : subtitleField.field === SearchResultFields.Vintage
                ? vintage
                : subtitleField.field === SearchResultFields.PageCount
                  ? pageCount
                  : notKnown;
            context: { $implicit: subtitleField.value }
          "
        />
        @if (!last) {
          <span>, </span>
        }
      }

      <!-- <ng-container *ngIf="!!period?.length; else notKnown">
      <ng-container *ngFor="let p of period; first as first">
        <span *ngIf="!first"> - </span>
        <span>{{ p | date: "d. MMMM y" }}</span>
      </ng-container>
    </ng-container>
    <span *ngIf="vintage">, {{ "SEARCH_RESULT.VINTAGE" | translate:{ vintage:vintage } }}</span> -->
    </div>

    <div class="result-details">
      @for (object of resultDetails; track trackByFn($index, object)) {
        @if (object | objectLink: result : search; as link) {
          <a
            mat-stroked-button
            [routerLink]="link.routerLink"
            [queryParams]="link.queryParams"
            queryParamsHandling="merge"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopImmediatePropagation()"
            class="mat-btn-auto-height"
          >
            @if (object.chapterName) {
              <h4 class="chapter-name" [innerHTML]="object.chapterName"></h4>
            }
            @if (object.logicalPageNumber) {
              <span class="page-number"> {{ "SEARCH_RESULT.PAGE" | translate }} {{ object.logicalPageNumber }}: </span>
            }
            @if (object.fulltextSnippet) {
              <span class="fulltext-snippet" [innerHTML]="object.fulltextSnippet"></span>
            }
          </a>
        }
      }
    </div>

    <!-- <ng-container *ngIf="result.page">
      <div class="content">
        <span>{{ "SEARCH_RESULT.PAGE" | translate }} {{ result?.page }}</span>
      </div>
    </ng-container>

    <div *ngIf="result?.content"
      class="content">
      <span [innerHTML]="result?.content"></span>
    </div>

    <div *ngIf="object?.fulltextSnippet"
      class="content">
      <span [innerHTML]="object?.fulltextSnippet"></span>
    </div> -->
  </div>
</div>

<ng-template #notKnown>
  <!-- <span>{{ "DATABASE.NOT_KNOWN" | translate }}</span> -->
</ng-template>

<ng-template #period let-period>
  @for (p of period; track p; let first = $first) {
    @if (!first) {
      <span> - </span>
    }
    <span>{{ p | date: "d. MMMM y" }}</span>
  }
</ng-template>

<ng-template #vintage let-vintage>
  {{ "SEARCH_RESULT.VINTAGE" | translate: { vintage: vintage } }}
</ng-template>

<ng-template #pageCount let-pageCount>
  {{ "SEARCH_RESULT.PAGES" | translate: { pages: pageCount } }}
</ng-template>
